import script from "./RTBCampaignStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./RTBCampaignStatistics.vue?vue&type=script&setup=true&lang=js"

import "./RTBCampaignStatistics.vue?vue&type=style&index=0&id=bba05a96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba05a96"]])

export default __exports__